import {Button, Modal} from "react-bootstrap";
import {mediumTextStyles, regularTextStyles} from "../Style";

function ContinueOfflinePopupTFAF2(props) {
    const handleClose = () => {
        props.setParentContinueOfflinePopupShow(false);
    };


    return (
        <>
            <Modal
                show={props.parentContinueOfflinePopupShow}
                onHide={handleClose}

                backdrop="static"
                size="lg"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title style={mediumTextStyles}><span style={{color: 'red'}}>Sorry</span> </Modal.Title>
                </Modal.Header>

                <Modal.Body style={regularTextStyles}>
                    <p>
                        We are unable to offer insurance for your car.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ContinueOfflinePopupTFAF2;